<ng-container *ngIf="useReportItemData; else machineEfficiency">
  <ng-container *ngIf="canSeeReportItemHeader && (reportItemHeader | reportItemFormat | async) as formattedReportItem">
    <div *ngIf="formattedReportItem" class="efficiency-wrapper" [class.low]="isLow()" [class.high]="isHigh()">
      <span>{{ formattedReportItem }}</span>
    </div>
  </ng-container>
</ng-container>
<ng-template #machineEfficiency
  ><div class="efficiency-wrapper" [class.low]="isLow()" [class.high]="isHigh()" *ngIf="hasEfficiency()">
    <span>{{ getEfficiencyValue() }}%</span>
  </div>
</ng-template>
